export default __webpack_public_path__ + "static/media/telemed1.9b6f960b.png";